"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTypes = exports.TransactionDirections = exports.TransactionAssetCategories = exports.TransactionStatuses = void 0;
var TransactionStatuses;
(function (TransactionStatuses) {
    TransactionStatuses["Pending"] = "Pending";
    TransactionStatuses["Completed"] = "Completed";
    TransactionStatuses["Reverted"] = "Reverted";
})(TransactionStatuses = exports.TransactionStatuses || (exports.TransactionStatuses = {}));
var TransactionAssetCategories;
(function (TransactionAssetCategories) {
    TransactionAssetCategories["External"] = "external";
    TransactionAssetCategories["Internal"] = "internal";
    TransactionAssetCategories["Token"] = "token";
})(TransactionAssetCategories = exports.TransactionAssetCategories || (exports.TransactionAssetCategories = {}));
var TransactionDirections;
(function (TransactionDirections) {
    TransactionDirections["Sender"] = "Sender";
    TransactionDirections["Receiver"] = "Receiver";
})(TransactionDirections = exports.TransactionDirections || (exports.TransactionDirections = {}));
var TokenTypes;
(function (TokenTypes) {
    TokenTypes["Erc20"] = "Erc20";
    TokenTypes["Erc721"] = "Erc721";
    TokenTypes["Erc1155"] = "Erc1155";
    TokenTypes["Native"] = "Native";
})(TokenTypes = exports.TokenTypes || (exports.TokenTypes = {}));
